import { WEEKDAY_KOREAN } from '../config/constants';

// 요일 문자열에서 영어 요일을 한글로 교체
export const replaceWeekdaysInString = (text: string): string => {
  let result = text;

  Object.entries(WEEKDAY_KOREAN).forEach(([english, korean]) => {
    const regex = new RegExp(english, 'gi');
    result = result.replace(regex, korean);
  });

  return result;
};
